document.addEventListener('DOMContentLoaded', function() {

  // Your original accordion function with smooth animation
  function accordion(acc_btn) {
    $(acc_btn).on("click", function () {
      if ($(this).parent().find(".content").css("display") == "none") {
        $(this).parent().parent().parent().find(".content").slideUp("slow");
        $(this).parent().parent().parent().find(".arrow").removeClass("rotate");
        $(this).parent().parent().parent().find(".a_active").removeClass("a_active");
        $(this).parent().find(".content").slideDown("slow");
        $(this).parent().find(".arrow").addClass("rotate");
        $(this).parent().addClass("a_active");
      } else {
        $(this).parent().find(".content").slideUp("slow");
        $(this).find(".arrow").removeClass("rotate");
        $(this).parent().parent().parent().find(".a_active").removeClass("a_active");
      }
    });
  }

  accordion(".accordion-btn");

    $('.bbw-slick-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        speed: 1000,
        dots: true,
        prevArrow: $('.slick-prev-news'), // Custom previous arrow
        nextArrow: $('.slick-next-news'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
    });

  


    $('.our-journey-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true,
        speed: 1000,
        customPaging: function(slider, i) {
          return '<button class="custom-dot">0' + (i + 1) + '</button>';
        }
      });
  
});